import React, { ReactElement } from 'react';

import { IQATestableProps } from '../../shared/types/IQATestableProps';
import { IStyleableProps } from '../../shared/types/IStyleableProps';
import { ICON_COLOR, ICON_TYPE, OzIcon } from '../icon/Icon';
import { ICON_SIZE } from '../icon/ICON_SIZE';

import styles from './CarouselPagination.module.css';

export type ICarouselPaginationProps = IQATestableProps & IStyleableProps & {
    currentPage: number;
    totalPages: number;
    onChange: (page: number) => void;
};

export function OzCarouselPagination (props: ICarouselPaginationProps): ReactElement {
    const {
        currentPage,
        totalPages,
        onChange,
        'data-testid': dataTestId = '',
    }: ICarouselPaginationProps = props;

    function handlePreviousClick () {
        let page: number = currentPage - 1;

        if (page < 1) {
            page = 1;
        }

        onChange(page);
    }

    function handleNextClick (): void {
        let page: number = currentPage + 1;

        if (page > totalPages) {
            page = totalPages;
        }

        onChange(page);
    }

    return (
        <div className="flex flex-row" data-testid={dataTestId}>
            <div className="text-sm font-bold font-gellix mr-5">
                <span>{currentPage} / {totalPages}</span>
            </div>
            <button aria-label="Previous" className={`${styles.previousArrow}`} disabled={currentPage <= 1} onClick={handlePreviousClick}>
                <OzIcon
                    type={ICON_TYPE.OZ_ARROW_LEFT}
                    size={ICON_SIZE.LARGE}
                    className="mr-5"
                    color={ICON_COLOR.DARK}
                    alt="Arrow Left"
                />
            </button>
            <button aria-label="Next" className={`${styles.nextArrow}`} disabled={currentPage >= totalPages} onClick={handleNextClick}>
                <OzIcon
                    type={ICON_TYPE.OZ_ARROW_RIGHT}
                    size={ICON_SIZE.LARGE}
                    color={ICON_COLOR.DARK}
                    alt="Arrow Right"
                />
            </button>
        </div>
    );
}
